import { useEffect, useState } from "react";
import { api } from "../lib/api";

const CENTS = (c) => (c == null ? "$0.00" : `$${(Math.abs(c) / 100).toFixed(2)}`);

/**
 * R9 § 4 — Reward highlight card on catalogue ordering pages.
 * Compact. Server-authoritative. Does no math. When the user has a preview
 * quote in a later step, the Order Summary is still the authoritative surface.
 */
export default function RewardHighlightCard() {
  const [available, setAvailable] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Prepare a probe quote with a placeholder 1x SKU is unnecessary — the
        // /orders/mine endpoint's echoed available_reward_cents field on a
        // freshly-prepared quote would tie us to the cart. Instead, fetch it
        // via a light server-only helper: /reward/available (if present) OR
        // fall back to a probe quote with no lines (rejected — 422). We
        // simply omit Available if we cannot fetch it non-invasively.
        const r = await api.get("/reward/available");
        if (!cancelled && typeof r.data?.available_reward_cents === "number") {
          setAvailable(r.data.available_reward_cents);
        }
      } catch (_) {
        // No dedicated endpoint yet — panel still renders the policy card.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <aside
      className="apwo-panel apwo-reward-highlight"
      data-testid="catalogue-reward-highlight"
      role="complementary"
      aria-label="Prepay Reward"
    >
      <div className="apwo-reward-hl-head">
        <span className="apwo-reward-hl-pill">Prepay Reward</span>
        {available != null && (
          <span className="apwo-reward-hl-avail" data-testid="catalogue-reward-available">
            Available: <strong>{CENTS(available)}</strong>
          </span>
        )}
      </div>
      <p className="apwo-reward-hl-line" data-testid="catalogue-reward-copy">
        Earn 1.5% Reward when your eligible Prepay product total remains
        <strong> $4,000+ ex GST </strong> after any Reward used.
      </p>
    </aside>
  );
}
